// extracted by mini-css-extract-plugin
export var banner = "exercises-module--banner--3tP7i";
export var list = "exercises-module--list--t9C1H";